import { KeysToCamelCase, CycleWithRels } from '@statsbomb/parachute-types';
import { atom } from 'jotai';
import { PromiseAtom } from '@/types/atom';
import { NumberOption } from '@/types/generic';
import { convertToDropdownOption, replaceOptionalKeyIfExistingValueFalsy } from '../object';

type EntityCyclesAtom = PromiseAtom<KeysToCamelCase<CycleWithRels>[]>;

export const createCompetitionOptionsAtom = (entityCyclesAtom: EntityCyclesAtom) =>
  atom(async get => {
    const entityCycles = await get(entityCyclesAtom);

    return Object.values(
      entityCycles.reduce(
        (acc, { competition: { name, competitionId, areaCode }, cycle: { has360, hasPhysical } }) => {
          if (!acc[competitionId]) acc[competitionId] = convertToDropdownOption(name, competitionId);

          acc[competitionId].optional = replaceOptionalKeyIfExistingValueFalsy(
            'countryCode',
            acc[competitionId].optional,
            areaCode,
          );

          acc[competitionId].optional = replaceOptionalKeyIfExistingValueFalsy(
            'is360',
            acc[competitionId].optional,
            has360,
          );

          acc[competitionId].optional = replaceOptionalKeyIfExistingValueFalsy(
            'isPhysical',
            acc[competitionId].optional,
            hasPhysical,
          );

          return acc;
        },
        {} as Record<number, NumberOption>,
      ),
    );
  });

export const createSeasonOptionsAtom = (entityCyclesAtom: EntityCyclesAtom) =>
  atom(async get => {
    const entityCycles = await get(entityCyclesAtom);

    const sortedSeasonOptions = Object.values(
      entityCycles.reduce(
        (acc, { season: { name, seasonId } }) => ({
          ...acc,
          [seasonId]: convertToDropdownOption(name, seasonId),
        }),
        {} as Record<number, NumberOption>,
      ),
    )
      .sort((a, b) => a.label.localeCompare(b.label))
      .reverse();

    return sortedSeasonOptions;
  });
